import type { AccrualsRepositoryT } from "../../domain/ports/accruals.repository";
import type { AccrualRowT } from "../../domain/types/accrual.types";
import type { AccrualLoadResultT } from "../../domain/entities/accrual.entity";

type CreateAccrualParamsT = {
  accrualsRepository: AccrualsRepositoryT;
  rows: AccrualRowT[];
  colaboraInstanceId: string;
};

export const createAccrual = async ({
  accrualsRepository,
  rows,
  colaboraInstanceId,
}: CreateAccrualParamsT): Promise<AccrualLoadResultT> =>
  accrualsRepository.create(rows, colaboraInstanceId);
